export default class Ocorrencia {
    constructor() {
        this.id = null;
        this.dia = null;
        this.abrangeFaltas = false;
        this.abrangeAtrasos = false;  
        this.abrangeSaidaAntecipada = false;  
        this.abrangeExcessoRefeicao = false;  
        this.abrangeFaltaMarcacao = false;  
        this.observacao = '';
        this.usuarioJustificativa = '';
    }    
}